export default __webpack_public_path__ + "css.b51c7a28.png";